module.exports = "/_next/static/images/pizza_make-436dfc37cd99b55e766cccb1fa68408d.jpg";